import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './../src/styles/main.scss';
import App from './pages/receipts';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(

  <div className="container">
    <App />
  </div>

);

